
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMemberGrid extends Serenity.EntityGrid<PsMemberRow, any> {
        protected getColumnsKey() { return PsMemberColumns.columnsKey; }
        protected getDialogType() { return PsMemberDialog; }
        protected getIdProperty() { return PsMemberRow.idProperty; }
        protected getInsertPermission() { return PsMemberRow.insertPermission; }
        protected getLocalTextPrefix() { return PsMemberRow.localTextPrefix; }
        protected getService() { return PsMemberService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );   
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsMemberService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));          
            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CustGroupName"]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}